import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { limits } from 'chroma-js';
import { LocalStorageService } from '../localstorage.service';

@Injectable({
    providedIn: 'root'
})
export class PaymentsService {
    get paymentsURL(): string{
        return `${this.datacollectorservice.baseurl()}/payments/`;
    }
    get paymentsApiUrls(): any{
        return {
            dataUrl: this.paymentsURL+'transactions/filter',
            paymentsURL: this.paymentsURL+'transactions',
            filterUrl: this.paymentsURL+'transactions/meta/filter',
            payoutsUrl:`${this.paymentsURL}zuper_pay/payouts`,
            disputeUrl: `${this.paymentsURL}zuper_pay/disputes`,
            refundUrl:`${this.paymentsURL}zuper_pay/refunds`,
            bulkActionUrl: `${this.datacollectorservice.baseurl()}/payments/bulk_action`,
        };
    }
    get paymentsStasURL(): string {
        return`${this.datacollectorservice.baseurl()}/analytics/payments/`;
    }
    get exportUrl(): string {
        return `${this.datacollectorservice.baseurl()}/reports/customer/payment_transactions`;
    }
    constructor(private http: HttpClient,private datacollectorservice: DataCollectorService, private localStorageService: LocalStorageService) {}

    getTransactionDetailUrl(paymentTransactionUid): string {
        return this.paymentsURL+`${paymentTransactionUid}/transactions`;
    }

    getTransactionDetails(paymentTransactionUid): Observable<any> {
        const paymentsURL = this.getTransactionDetailUrl(paymentTransactionUid);
        return this.datacollectorservice.getData(paymentsURL);
    }
    getPaymentDetails(payload): Observable<any> {
        const paymentsUrl = this.paymentsApiUrls.paymentsURL;
        return this.datacollectorservice.getData(paymentsUrl,payload);
     }

    refreshPaymentTransactionStatus(data): Observable<any>{
        const paymentsURL = this.paymentsURL+'payment_intent';
        return this.datacollectorservice.putData(paymentsURL, data);
    }
    getPaymentProvider(): Observable<any>{
        const paymentsURL = this.paymentsURL + 'provider';
        return this.datacollectorservice.getData(paymentsURL);
    }

    sendReceipt(paymentTransactionUid): Observable<any>{
        const paymentsURL = this.paymentsURL+`${paymentTransactionUid}/send_customer_receipt`;
        return this.datacollectorservice.postData(paymentsURL,'');
    }

    voidTransaction(paymentTransactionUid: string): Observable<any> {
        const paymentsURL = this.paymentsURL + `transactions/${paymentTransactionUid}/void_payment`;
        return this.datacollectorservice.putData(paymentsURL, '');
    }

    getPaymentsTrends(payload: any): Observable<any>{
        const url = this.paymentsStasURL +'trends';
        return this.datacollectorservice.getData(url,payload);
    }
    getPaymentsStats(payload: any): Observable<any>{
        const url = this.paymentsStasURL +'stats';
        return this.datacollectorservice.getData(url,payload);
    }
    getAllPayments(payload): Observable<any>{
        const url = this.paymentsApiUrls.dataUrl;
        return this.datacollectorservice.postData(url,payload);
    }
    getPaymentsMetaFilter(): Observable<any>{
        const url = this.paymentsApiUrls.filterUrl;
        return this.datacollectorservice.getData(url);
    }
    getPayouts(): Observable<any>{
        const url = this.paymentsApiUrls.payoutsUrl;
        return this.datacollectorservice.getData(url);
    }
    getDisputes(payload): Observable<any>{
        const url = this.paymentsApiUrls.disputeUrl;
        return this.datacollectorservice.getData(url,payload);
    }
    getAllDisputes(): Observable<any>{
        const payload = {
            limit: 10
        };
        const url = this.paymentsApiUrls.disputeUrl;
        return this.datacollectorservice.getData(url,payload);
    }
    getAllRefunds(payload): Observable<any>{
        const url = this.paymentsApiUrls.refundUrl;
        return this.datacollectorservice.getData(url,payload);
    }
    exportPayments(payload): Observable<any>{
        return this.datacollectorservice.getBlobContent(this.exportUrl,payload);
    }

    getPaymentProviderData(): any {
        const paymentsURL = this.paymentsURL + 'provider';       
        this.datacollectorservice.getData(paymentsURL).subscribe(response => {
            this.localStorageService.setLocalStorage('paymentProvider', JSON.stringify(response?.data));
        });
    }
    
}
